export default __webpack_public_path__ + "static/media/livenyte-logo-with-background.50052884.jpg";